<template>
  <div>
    <el-dialog
      :id="$options.name"
      :before-close="noDialog"
      :fullscreen="dialogFullscreen"
      :visible.sync="dialog"
      title="小区统计"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <el-form ref="Dto" :model="configForm" :rules="rules" label-width="auto">
        <el-row :gutter="5">
          <el-col :span="12" :xs="24">
            <el-form-item
              label="近7日端口使用率："
              prop="last7DayAverageUsageRate"
            >
              <span>{{ configForm.last7DayAverageUsageRate || "0.00" }}%</span>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer">
        <el-button @click="noDialog">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import dialogMixin from "@/mixin/dialogMixin";

import agentSearchLast7DayChargeNumByGroupId from "@/api/fund/order-manage/agentSearchLast7DayChargeNumByGroupId";
import resDispose from "@/mixin/resDisposeMixin";

export default {
  name: "groupStatisticsDialog",
  mixins: [dialogMixin, resDispose],
  props: {
    dialog: Boolean,
    groupStatisticsId: Number,
  },
  data() {
    return {
      configForm: {},
      rules: {},
    };
  },
  watch: {
    groupStatisticsId: {
      handler(newV) {
        if (newV) {
          this.fetchData();
        }
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    fetchData() {
      agentSearchLast7DayChargeNumByGroupId({
        id: this.groupStatisticsId,
      }).then((res) => {
        this.configForm = res.data;
      });
    },
  },
};
</script>
<style lang="scss" scoped></style>
